import { InfoCircleTwoTone } from "@ant-design/icons";
import styled from "styled-components";

export const StyledDashboardInfoBlock = styled("div")`
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 14px;
    background-color: ${(props) => props.theme.collapseHeaderBackground};
    border-radius: 8px !important;

    margin-top: 12px;
    margin-bottom: 12px;
`;

export const StyledDashboardInfoIcon = styled(InfoCircleTwoTone)`
    font-size: 24px;
`;
